//Список рекомендуемых действий для локальных копий.
var LocalCopyRecommendedAction = {};

/*Обработчики действий над локальными копиями*/

function ReturnLocalCopyCM(obj) {
  var item = obj.tr;
  var version = item.attr('version');
  var encoding = item.attr('encoding');
  var pluginName = item.attr('encpluginname');
  ReturnLocalCopy(obj.id, version, !!encoding ? encoding : '', !!pluginName ? pluginName : '');
}

//Вернуть локальную копию
function ReturnLocalCopy(documentID, versionNumber, encodingType, pluginName, fileName, editDate) {
  Core.agent.getPlugin('edmsplugin').done(function (plugin) {
    var OnConfirmRecoverLocalCopy = function (dialog, additionalParams) {
      var params = { "DocumentID": documentID, "Version": versionNumber, "EncodeType": encodingType, "EncryptionPluginName": pluginName };

      if (!!additionalParams) $.extend(params, additionalParams);

      _returnLocalCopyRequest(params, function (result) {
        var resultMessage = L('RECOVER_FROM_LOCAL_COPY_SUCCESS');
        ShowTopSpinnerResult(resultMessage);
        RemoveItemFromRecoveryList(documentID, versionNumber);
      }, function (err) {
        var resultMessage = "";
        try {
          resultMessage = err.message;
        } catch (e) {
          resultMessage = L('RECOVER_FROM_LOCAL_COPY_FAIL');
        }
        ShowError(resultMessage);
      });
    }
    var modifyDate = formatDateTime(new Date(editDate ? editDate : GetLastEditDate(documentID, versionNumber)));
    var confirm = (format(L("CONFIRM_RECOVER_FROM_LOCAL_COPY"), { 0: versionNumber, 1: (fileName ? fileName : GetDocumentFileName(documentID)) })).escapeHtml();
    var warning = LocalCopyRecommendedAction[(documentID + 'v' + versionNumber)] == 'RECOVER' ? "" : (format(L("MSG_DELETE_COPY"), { 0: modifyDate })).escapeHtml();
    ShowDocumentRecoveryConfirmation(confirm, warning, function (dialog) {
      if (GetDocumentEncodingType(documentID) >= 2) {
        RequestPasswordForDecryption(null, function (pass) { OnConfirmRecoverLocalCopy(dialog, { Password: pass }); });
        return;
      }
      OnConfirmRecoverLocalCopy(dialog, null);
    });
  });
}

// Возврат документа, открытого в агенте.
function ReturnDocument(documentID, versionNumber, encodingType, pluginName, fileName, editDate) {
  Core.agent.getPlugin('edmsplugin').done(function (plugin) {
    var OnConfirmRecoverLocalCopy = function (additionalParams) {
      var params = { "DocumentID": documentID, "Version": versionNumber, "EncodeType": encodingType, "EncryptionPluginName": pluginName };
      if (!!additionalParams) $.extend(params, additionalParams);
      _returnLocalCopyRequest(params, function (result) {
        var resultMessage = L('AGENT_RETURN_DOCUMENT_SUCCESS');
        ShowTopSpinnerResult(resultMessage);
        RemoveItemFromRecoveryList(documentID, versionNumber);
      }, function (err) {
        var resultMessage = "";
        try {
          resultMessage = err.message;
        } catch (e) {
          resultMessage = L('AGENT_RETURN_DOCUMENT_FAIL');
        }
        ShowError(resultMessage);
      });
    }

    if (GetDocumentEncodingType(documentID) >= 2) {
      RequestPasswordForDecryption(null, function (pass) { OnConfirmRecoverLocalCopy({ Password: pass }); });
      return;
    }
    OnConfirmRecoverLocalCopy(null);
  });
}

// Запрос на возврат документа из локальной копии.
function _returnLocalCopyRequest(params, successCallback, errCallback) {
  RequestToken(TOKEN_OPERATION.UPLOAD_DOCUMENT_BODY | TOKEN_OPERATION.DOWNLOAD_DOCUMENT_BODY, function (token) {
    $.extend(params, { "Token": token });

    Core.agent.invoke("ReturnLocalCopy", "edmsplugin", params).done(function (result) {
        successCallback(result);
    }).fail(function(result) {
      errCallback(result);
    });

  }, params['DocumentID'], params['Version']);
}

function getDocumentListItem(docID) {
  return $('.List')
    .filter('[mode=OpenedDocs], [mode=EDocRestore]')
    .filter('#' + docID);
}

function GetDocumentFileName(DocID) {
  var item = getDocumentListItem(DocID);
  var ext = item.find('svg.Icon32>use').attr('alt');
  var name = item.find('div.objectname').contents()[0];
  return (!!name.textContent ? name.textContent : name.nodeValue) + '.' + ext;
}

function GetLastEditDate(DocID, VersionNumber) {
  var date = getDocumentListItem(DocID)
    .filter('[version=' + VersionNumber + ']')
    .attr('localeditdate');
  return !!date ? date : "";
}

function GetDocumentEncodingType(DocID) {
  return getDocumentListItem(DocID).attr('encoding');
}

function GetEncodingPluginName(DocID) {
  return getDocumentListItem(DocID).attr('encpluginname');
}

function ShowDocumentRecoveryConfirmation(message, warning, onConfirm) {
  var dialog = new WA.components.dialogs.MessageBox();
  dialog.width = 600;
  dialog.okText = L("RESTORE");
  dialog.okCancelButtons(function () {
    dialog.disableButton("modal_ok_button");
    dialog.disableButton("modal_cancel_button");
    $('.ui-dialog-titlebar-close:visible', dialog._jDialog.parent()).remove();
    dialog._jDialog.find('.upper-area').hide().next().children().show();
    if (onConfirm) onConfirm(dialog);
  }, null);
  dialog.showQuestion(message, warning + GetConfirmRecoveryDlgHtml());
}

function ShowDocumentDeleteCopyConfirmation(message, warning, onConfirm) {
  var dialog = new WA.components.dialogs.MessageBox();
  dialog.width = 600;
  dialog.yesNoButtons(onConfirm, null);
  dialog.showQuestion(message, warning);
}

function GetConfirmRecoveryDlgHtml() {
  var html = '';
  var spinnerImage = 'spinner.gif';
  var spinnerHtml = $('<img src="images/' + spinnerImage + '">')[0].outerHTML;
  var recoveryProcMsg = $('<span>').html(L('DOCUMENT_RECOVER_PROCESS'))[0].outerHTML;
  html += $('<div>').html(spinnerHtml + recoveryProcMsg).attr('id', 'recovery_spinner').hide()[0].outerHTML;
  return html;
}

function OpenLocalCopyCM(obj) {
  OpenLocalCopy(obj.id, obj.tr.attr('version'));
}

//Открыть локальную копию
function OpenLocalCopy(documentID, versionNumber) {
  Core.agent.getPlugin('edmsplugin').done(function (plugin) {
    var params = { "DocumentID": documentID, "Version": versionNumber };
    plugin.invoke("OpenLocalCopy", params).fail(function (result) {
      try {
        var resultMessage = result.message;
        ShowMessage(resultMessage, L('INFO'));
      } catch (e) { }
    });
  });
}

function DeleteLocalCopyCM(obj) {
  DeleteLocalCopy(obj.id, obj.tr.attr('version'));
}

//Удалить локальную копию
function DeleteLocalCopy(documentID, versionNumber, OnDeleteCallback, SilentMode) {
  Core.agent.getPlugin('edmsplugin').done(function (plugin) {
    var OnConfirmDeleteLocalCopy = function () {
      var resultMessage = "";
      RequestToken(TOKEN_OPERATION.UNLOCK_VERSION, function (token) {
        var params = { "DocumentID": documentID, "Version": versionNumber, "Token": token };
        WebAccess.agent.transmitRequest("DeleteLocalCopy", "edmsplugin", params).done(function (result) {
          resultMessage = L('LOCAL_COPY_DELETE_SUCCESS');
          updateOpenedDocumentsWidget();
          if (!SilentMode) {
            ShowTopSpinnerResult(resultMessage);
          }
          RemoveItemFromRecoveryList(documentID, versionNumber);
          if (OnDeleteCallback) OnDeleteCallback();
        }).fail(function (result) {
          try {
            resultMessage = result.message;
          } catch (e) {
            resultMessage = L('LOCAL_COPY_DELETE_FAIL');
          }

          if (!SilentMode) ShowError(resultMessage);
        });
      }, documentID, versionNumber);
    }

    if (SilentMode) {
      OnConfirmDeleteLocalCopy();
    } else {
      var confirm = L("CONFIRM_DELETE_LOCAL_COPY");
      var warning = LocalCopyRecommendedAction[(documentID + 'v' + versionNumber)] == 'DELETE' ? "" : L("MSG_RECOVERY_FROM_COPY");
      ShowDocumentDeleteCopyConfirmation(confirm, warning, OnConfirmDeleteLocalCopy);
    }
  });
}

// Показать окно для обработки локальных копий.
function ShowLocalCopiesWindow(localCopies) {
  CallService("/ModalWindow.asmx/Create", { ControlName: "LocalCopiesProcess", Params: $.toJSON({ Documents: localCopies }) }, function (res) {
    if (res.Success) {
      var content = $(res.Result.html);
      if (content.children().length > 0) {
        var instruction = MakeInfoMessage(L(localCopies.length == 1 ? 'LOCAL_COPY_RECOVERY_INSTRUCTION' : 'LOCAL_COPIES_RECOVERY_INSTRUCTION'))[0].outerHTML;
        var dialog = new WebAccess.components.dialogs.BaseDialog({ wordWrap: false, maxHeight: 400 });
        dialog.title = L("EDOCUMENT_LOCAL_COPIES");
        dialog.setHtml(instruction + $('<div id="modal_window">').css('overflow-y', 'auto').css('overflow-x', 'hidden').css('position', 'relative').css('max-height', 400).html(content)[0].outerHTML);
        dialog.isShowOkButton = false;
        dialog.cancelText = L('CLOSE');
        dialog.isShowCancelButton = true;
        dialog.width = 630;
        dialog.show();
        BindHelpIcoClickOnModalWindow('RestoreDocuments', $('#dialog_content_' + dialog.id).parents('.ui-dialog'));
      }
      if (res.Result.initJs) {
        var f = new Function(res.Result.initJs);
        setTimeout(function () {
          f.apply(window);
        }, 10);
      }
    } else {
      if (res.Error == "NO_DOCS") { console.log('no local copies'); }
    }
    HideTopSpinner();
  });
}

function RemoveItemFromRecoveryList(DocID, Version) {
  var dialog = $('div[role=dialog]:visible');
  dialog.find('div#' + DocID + '[version=' + Version + ']').remove();
  if (IsRecoveryListEmpty(dialog)) {
    //AddEmptyItemToList(dialog);
    CloseRecoveryDialog(dialog);
  }
}

function AddEmptyItemToList(dialog) {
  dialog.find('#modal_window').children('span').append('<span>' + L("EMPTY") + '</span>');
}

function IsRecoveryListEmpty(dialog) {
  return dialog.find('#modal_window').find('.List').length == 0;
}

function CloseRecoveryDialog(dialog) {
  dialog.find('.ui-icon-closethick').click();
}

function updateOpenedDocumentsWidget() {
  if (Core.footer.openedDocumentsWidget)
    Core.footer.openedDocumentsWidget.update();
};